import React, { useState, useEffect } from "react";
import Layout from "../../Components/Layout";
import Styles from "./index.module.css";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import ReactLoading from "react-loading";
import { warningSwal } from "../../Util/Toast";
import Table from "./Table";
import Select from "react-select";
import moment from "moment";

function BatchFinishedReport() {
    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState(null);
    const [link, setLink] = useState("");
    const [tutorOptions, setTutorOptions] = useState([]);
    const [tutorSearch, setTutorSearch] = useState("");
    const [selectedTutor, setSelectedTutor] = useState(null);
    const [tutorSearchLoad, setTutorSearchLoad] = useState(false);

    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    useEffect(() => {
        const debouncedSearch = setTimeout(async () => {
            if (typeof tutorSearch === "string" && tutorSearch.length > 0) {
                setTutorSearchLoad(true);
                try {
                    const data = await Services.searchActiveTutor(
                        "POST",
                        JSON.stringify({ SearchString: tutorSearch }),
                        token
                    );
                    const formattedOptions = data.Tutors?.filter(
                        (item) => item.TutorStatus == 1
                    )?.map((tutor) => ({
                        label: `${tutor.FirstName} ${tutor.LastName}`,
                        value: tutor.TutorID,
                    }));
                    setTutorOptions(formattedOptions || []);
                } catch (error) {
                    console.error("Error fetching tutors:", error);
                    setTutorOptions([]);
                } finally {
                    setTutorSearchLoad(false);
                }
            } else {
                setTutorOptions([]);
            }
        }, 350);

        return () => clearTimeout(debouncedSearch);
    }, [tutorSearch]);

    const onSubmit = async (data) => {
        const TutorID = selectedTutor?.value || null;

        if (!data.FromDate || !data.ToDate) {
            warningSwal("Warning", "From Date and To Date are required");
            return;
        }

        if (data.FromDate > data.ToDate) {
            warningSwal("Warning", "Please select a valid date range");
            return;
        }

        const start = moment(data.FromDate);
        const end = moment(data.ToDate);
        if (end.diff(start, 'days') > 15) {
            warningSwal("Warning", "Date range cannot exceed 15 days");
            return;
        }

        setLoading(true);
        try {
            const res = await Services.batch_finished_report(
                "GET",
                null,
                token,
                data.FromDate || null,
                data.ToDate || null,
                data.Status || "all",
                TutorID
            );
            setLoading(false);
            if (res?.Status === 1) {
                setLink(res.CsvFile || "");
                setResults(
                    res.Results?.map((item) => ({
                        "Parent Full Name": item.ParentFullName || "Pending",
                        "Student Full Name": item.StudentFullName || "Pending",
                        "Phone Number": item.PhoneNumber || "Pending",
                        "Batch Name": item.BatchName,
                        "Teacher Name": item.TeacherName,
                        "RM Name": item.RMName,
                        "Created By": item.CreatedBy,
                        "Finished On": item.FinishedOn && item.FinishedOn !== "0000-00-00" ? moment(item.FinishedOn).format("DD-MM-YYYY") : "NA",
                        "First Completed Class": item.FirstCompletedClassDate && item.FirstCompletedClassDate !== "0000-00-00 00:00:00" ? moment.utc(item.FirstCompletedClassDate).local().format("DD-MM-YYYY HH:mm:ss") : "Pending",
                        "Last Completed Class": item.LastCompletedClassDate && item.LastCompletedClassDate !== "0000-00-00 00:00:00" ? moment.utc(item.LastCompletedClassDate).local().format("DD-MM-YYYY HH:mm:ss") : "Pending",
                        "Last Completed File": item.LastCompletedFileTaken || "Pending",
                        "Batch Status": item.BatchStatus,
                        "Completion Reason": item.CompletionReason,
                    })) || []
                );
            } else {
                console.error(res);
                warningSwal("Warning", res?.message || "Failed to fetch report");
            }
        } catch (err) {
            setLoading(false);
            console.error(err);
            warningSwal("Warning", "Something went wrong");
        }
    };



    return (
        <Layout Active={"Batch Finish Report"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Batch Finished Report</title>
            </Helmet>
            <div className={Styles["Container"]}>
                <div className={Styles["wrapper"]}>
                    <h3>Batch Finished Report</h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={Styles["form-control"]} style={{ flex: 2.5, minWidth: '250px' }}>
                            <label>Teacher <span className="important">*</span></label>
                            <div style={{ width: '100%' }}>
                                <Select
                                    options={tutorOptions}
                                    onInputChange={(val) => setTutorSearch(val)}
                                    onChange={(val) => setSelectedTutor(val)}
                                    value={selectedTutor}
                                    isClearable
                                    placeholder="Search teacher by name"
                                    isLoading={tutorSearchLoad}
                                />
                            </div>
                        </div>

                        <div className={Styles["form-control"]} style={{ flex: 1, minWidth: '130px' }}>
                            <label>From Date <span className="important">*</span></label>
                            <input type="date" {...register("FromDate")} />
                            {errors.FromDate && <span style={{ color: 'red', fontSize: '12px' }}>From Date is required</span>}
                        </div>
                        <div className={Styles["form-control"]} style={{ flex: 1, minWidth: '130px' }}>
                            <label>To Date <span className="important">*</span></label>
                            <input type="date" {...register("ToDate")} />
                            {errors.ToDate && <span style={{ color: 'red', fontSize: '12px' }}>To Date is required</span>}
                        </div>
                        <div className={Styles["form-control"]} style={{ flex: 1, minWidth: '150px' }}>
                            <label>Status</label>
                            <select {...register("Status")} defaultValue={"all"}>
                                <option value="all">All</option>
                                <option value="4">Gone Cold</option>
                                <option value="3">Course Completed</option>
                                <option value="5">Batch Dissolved</option>
                                <option value="6">Parent discontinued</option>
                            </select>
                        </div>

                        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                            <button
                                type="submit"
                                disabled={loading}
                                className={`${Styles.btn} ${Styles.btnPrimary}`}
                                style={{ alignSelf: "flex-end", marginBottom: errors.FromDate || errors.ToDate ? "20px" : "0" }}
                                aria-busy={loading}>
                                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                                    {loading && <ReactLoading type="spokes" color="#0077b6" height={14} width={14} />}
                                    {loading ? "Submitting..." : "Submit"}
                                </span>
                            </button>

                            {link && (
                                <button
                                    type="button"
                                    className={`${Styles.btn} ${Styles.btnExport}`}
                                    style={{ alignSelf: "flex-end", marginBottom: errors.FromDate || errors.ToDate ? "20px" : "0" }}
                                    onClick={() => window.open(link, "_blank")}>
                                    Export
                                </button>
                            )}
                        </div>
                    </form>

                    {results && (
                        <div style={{ overflow: "auto", marginTop: 16 }}>
                            <Table
                                data={results}
                                emptyHeaders={[
                                    "Parent Full Name",
                                    "Student Full Name",
                                    "Phone Number",
                                    "Batch Name",
                                    "Teacher Name",
                                    "RM Name",
                                    "Created By",
                                    "Finished On",
                                    "First Completed Class",
                                    "Last Completed Class",
                                    "Last Completed File",
                                    "Batch Status",
                                    "Completion Reason"
                                ]}
                                style={{ minWidth: "1500px" }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default BatchFinishedReport;
